import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import 'reset-css/reset.css';
import '../color/color';
import '../color/color-hsl';
import '../typography/typography';
import css from './form-check-label.css';

const FormCheckLabel = ({ isDisabled, ...otherProps }) => (
  // disabled lint warning because `htmlFor` is the
  // responsibility of the parent component
  // eslint-disable-next-line jsx-a11y/label-has-associated-control
  <label
    className={classnames(css['ds-form-check-label'], {
      [css['ds-form-check-label--disabled']]: isDisabled,
    })}
    {...otherProps}
  />
);

FormCheckLabel.defaultProps = {
  isDisabled: false,
};

FormCheckLabel.propTypes = {
  isDisabled: PropTypes.bool,
};

export default FormCheckLabel;
